import React, { useContext } from 'react'
import Arc from '../../styles/arc'
import { LabelExtra, PercentLabel, SizedWrapper } from '../../styles/elements'
import { getPersianNumber } from '../../utils/number'
import { Icon } from '../../styles/image'
import { LocaleContext } from '../../routes'

export default ({ percent, width, isPassed, minNumOfRides, }) => {
  const locale = useContext(LocaleContext)
  const strokePercent = Math.max(percent / 100 * width * 3.14 - 1, 0);
  const fullBase = width * 3.2;
  var color = percent === 100 ? "#47BB82" : "#4185F4";
  return (
    <SizedWrapper positioned centered>
      {isPassed ?
        <>
          <Arc>
            <circle
              r={width / 2} cx="50%" cy="50%"
              stroke="#D9E7FD"
              fill="none"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray={fullBase}>
            </circle>
            <circle
              className="percent"
              r={width / 2} cx="50%" cy="50%"
              stroke={color}
              fill="none"
              strokeWidth="3"
              strokeLinecap="round"
              strokeDasharray={`${strokePercent} ${fullBase}`}>
            </circle>
          </Arc>
          <PercentLabel
            align="center"
            color={color}>
            {getPersianNumber(percent)}%
        </PercentLabel>
        </>
        :
        <SizedWrapper width="50px" height="50px" centered>
          <Icon width="24px" src={require('../../assets/images/lock.svg')} />
          <LabelExtra fontSize="12px">{getPersianNumber(minNumOfRides) + " " + locale.TRIP}</LabelExtra>
        </SizedWrapper>
      }
    </SizedWrapper>
  )
}
